module.exports = __webpack_public_path__ + "static/media/uncheckedCheckBox.688909a4.svg";